export default __webpack_public_path__ + "static/media/patients_new.dcb6bfd8.jpg";